// Google Fonts - כל הפונטים העבריים
const GOOGLE_FONTS = [
    { name: 'ברירת מחדל', value: 'inherit' },

    // פונטים עבריים מ-Google Fonts (ממוינים א-ב)
    { name: 'Alef - אלף', value: 'Alef' },
    { name: 'Amatic SC - אמטיק', value: 'Amatic SC' },
    { name: 'Arimo - ארימו', value: 'Arimo' },
    { name: 'Assistant - אסיסטנט', value: 'Assistant' },
    { name: 'Cairo - קהיר', value: 'Cairo' },
    { name: 'Cousine - קוזין', value: 'Cousine' },
    { name: 'David Libre - דוד ליברה', value: 'David Libre' },
    { name: 'Frank Ruhl Libre - פרנק רוהל', value: 'Frank Ruhl Libre' },
    { name: 'Heebo - היבו', value: 'Heebo' },
    { name: 'IBM Plex Sans Hebrew - IBM', value: 'IBM Plex Sans Hebrew' },
    { name: 'Karantina - קרנטינה', value: 'Karantina' },
    { name: 'M PLUS 1p - M פלוס', value: 'M PLUS 1p' },
    { name: 'Miriam Libre - מרים ליברה', value: 'Miriam Libre' },
    { name: 'Noto Rashi Hebrew - נוטו רש"י', value: 'Noto Rashi Hebrew' },
    { name: 'Noto Sans Hebrew - נוטו סאנס', value: 'Noto Sans Hebrew' },
    { name: 'Noto Serif Hebrew - נוטו סריף', value: 'Noto Serif Hebrew' },
    { name: 'Rubik - רוביק', value: 'Rubik' },
    { name: 'Secular One - סקולר', value: 'Secular One' },
    { name: 'Suez One - סואץ', value: 'Suez One' },
    { name: 'Tinos - טינוס', value: 'Tinos' },
    { name: 'Varela Round - ורלה', value: 'Varela Round' },
];

/**
 * טוען פונט מ-Google Fonts באופן דינמי
 * @param {string} fontFamily - שם הפונט לטעינה
 */
const loadGoogleFont = (fontFamily) => {
    if (!fontFamily || fontFamily === 'inherit') return;

    const cleanFont = fontFamily.replace(/['"]/g, '').trim();

    // בדיקה אם הפונט כבר נטען בדף
    const existingLink = document.querySelector(`link[href*="${cleanFont.replace(/ /g, '+')}"]`);
    if (existingLink) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${cleanFont.replace(/ /g, '+')}:wght@300;400;500;600;700&display=swap`;
    document.head.appendChild(link);
};

export { GOOGLE_FONTS, loadGoogleFont };
